/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-gray-800 bg-[#121212] py-4 text-center text-sm text-gray-400 w-full shrink-0">
      <div className="flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 md:space-x-8 px-4">
        <p>&copy; {new Date().getFullYear()} SnipIT by DevIT Systems. All rights reserved.</p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/about" className="hover:text-blue-400 transition-colors">About Company</Link>
          <Link to="/privacy" className="hover:text-blue-400 transition-colors">Privacy Policy</Link>
          <Link to="/license" className="hover:text-blue-400 transition-colors">License Agreement</Link>
          <Link to="/contact" className="hover:text-blue-400 transition-colors">Contact Developer</Link>
          <Link to="/security" className="hover:text-blue-400 transition-colors">Security</Link>
          <Link to="/changelog" className="hover:text-blue-400 transition-colors">Changelog</Link>
        </div>
      </div>
    </footer>
  );
}
